import React, { useEffect } from 'react';
import SyringeIcon from '../../../icons/SyringeBlue.svg';
import LightBulbIcon from '../../../icons/LightBulb.svg';
import FormGroup from '@material-ui/core/FormGroup';
import { CheckboxInput } from '../../Helpers/Inputs';
import { object, string } from 'yup';
import SvgIcon from '@material-ui/core/SvgIcon';
import Button from '@material-ui/core/Button';
import { Form, Row, Col, Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { createTheme, ThemeProvider } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { alpha } from '@material-ui/core/styles';
import './MedicalHistory.scss';


const useStyles = makeStyles(theme => ({
  boxBackground: {    
    backgroundColor: alpha(theme.palette.primary.main, .1),
  },
  insideTextColor: {
    color: theme.palette.primary.main
  },
  lightBackground: {
    backgroundColor: `${theme.palette.primary.main}16`,
  },
}));

const medicalHistoryTheme = {
  overrides: {
    MuiFormControl: {
      root: {
        marginBottom: 4,
      },
    },
    MuiFormControlLabel: {
      root: {
        alignItems: "flex-start",
        marginTop: 0,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: -2,
        paddingRight: 10,
      },
      label: {
        paddingTop: 4,
      },
    },
    MuiCheckbox: {
      root: {
        color: "#c6c6c6",
        marginRight: 8,
        padding: 0,
      },
    },
  },
};

export default function MedicalHistory(props) {

  const classes = useStyles();

  const { register, errors, handleSubmit, setValue, triggerValidation, reset } = useForm({
    validationSchema: MedicalHistory.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const noneOfTheAboveDisabled =
    props.formState.mildAsthma ||
    props.formState.severeAsthma ||
    props.formState.mildAnxietyDepression ||
    props.formState.severeAnxietyDepression ||
    props.formState.bipolar ||
    props.formState.cardiovascularheartDisease ||
    props.formState.cancer ||
    props.formState.chronsUlcerativeColitis ||
    props.formState.copd ||
    props.formState.diabetes ||
    props.formState.hivaids ||
    props.formState.highCholesterol ||
    props.formState.kidneyDisease ||
    props.formState.hypertensionOrHighBloodPressure ||
    props.formState.rheumatoidArthritis ||
    props.formState.sleepApnea ||
    props.formState.strokeTia;
  const handleCheckBoxValue = (field, value) => {
    if (field === 'none' && !value) {
      if (!noneOfTheAboveDisabled) {
        return false;
      }
    }
    props.onFieldChange(field, value);
  };

  useEffect(() => {
    register({ name: 'mildAsthma' });
    setValue('mildAsthma', props.formState.mildAsthma);

    register({ name: 'severeAsthma' });
    setValue('severeAsthma', props.formState.severeAsthma);

    register({ name: 'mildAnxietyDepression' });
    setValue('mildAnxietyDepression', props.formState.mildAnxietyDepression);

    register({ name: 'severeAnxietyDepression' });
    setValue('severeAnxietyDepression', props.formState.severeAnxietyDepression);

    register({ name: 'bipolar' });
    setValue('bipolar', props.formState.bipolar);

    register({ name: 'cardiovascularheartDisease' });
    setValue('cardiovascularheartDisease', props.formState.cardiovascularheartDisease);

    register({ name: 'cancer' });
    setValue('cancer', props.formState.cancer);

    register({ name: 'chronsUlcerativeColitis' });
    setValue('chronsUlcerativeColitis', props.formState.chronsUlcerativeColitis);

    register({ name: 'copd' });
    setValue('copd', props.formState.copd);

    register({ name: 'diabetes' });
    setValue('diabetes', props.formState.diabetes);

    register({ name: 'hivaids' });
    setValue('hivaids', props.formState.hivaids);

    register({ name: 'highCholesterol' });
    setValue('highCholesterol', props.formState.highCholesterol);

    register({ name: 'hypertensionOrHighBloodPressure' });
    setValue('hypertensionOrHighBloodPressure', props.formState.hypertensionOrHighBloodPressure);

    register({ name: 'kidneyDisease' });
    setValue('kidneyDisease', props.formState.kidneyDisease);

    register({ name: 'rheumatoidArthritis' });
    setValue('rheumatoidArthritis', props.formState.rheumatoidArthritis);

    register({ name: 'sleepApnea' });
    setValue('sleepApnea', props.formState.sleepApnea);

    register({ name: 'strokeTia' });
    setValue('strokeTia', props.formState.strokeTia);

    register({ name: 'none' });
    setValue('none', props.formState.none);
  }, [register]);

  // uncheck "none" if it becomes disabled
  useEffect(() => {
    if (!noneOfTheAboveDisabled && !props.formState.none) {
      props.onFieldChange('none', true);
    }else if (noneOfTheAboveDisabled && props.formState.none) {
      props.onFieldChange('none', false);
    }
  }, [noneOfTheAboveDisabled]);

  return (
    <ThemeProvider theme={(theme) => createTheme({
      ...theme,
      ...medicalHistoryTheme,
    })}>
      <Container className="medical-history-form personalize-step">
        <Form onSubmit={handleSubmit(props.onNext)}>
          <Row className="justify-content-center">
            <Col lg={5} className="medical-history-container">
              <Row className="justify-content-center pt-2">
                <div className={`icon-container ${classes.lightBackground}`}>
                  <SvgIcon component={SyringeIcon} color='primary' fontSize="large" />
                </div>

              </Row>
              <Row className="justify-content-center mainTitle">
                <h4>Medical History</h4>
              </Row>
              <Row>
                <p className={`titleBox ${classes.boxBackground}`}>
                  <span className={`insideTitle ${classes.insideTextColor}`}>
                    <SvgIcon component={LightBulbIcon} color='primary' />
                    Insider Tip:{' '}
                  </span>
                  <span className="insideText"> By answering a few more questions we can personalize your quote to ensure you get the most accurate price.</span>
                </p>
              </Row>
              <Row>
                <h5 className="subTitle">I have been diagnosed with or treated for:</h5>
              </Row>
              <Row>
                <FormGroup className="checkboxes">
                  <CheckboxInput
                    className="checkBoxInput"
                    name="mildAsthma"
                    id="mildAsthma"
                    checked={props.formState.mildAsthma}
                    onChange={(e) => handleCheckBoxValue('mildAsthma', e.target.checked)}
                    errors={errors && errors.mildAsthma}
                    inputRef={register}
                    label="Asthma - Mild/Seasonal"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="severeAsthma"
                    id="severeAsthma"
                    checked={props.formState.severeAsthma}
                    onChange={(e) => handleCheckBoxValue('severeAsthma', e.target.checked)}
                    errors={errors && errors.severeAsthma}
                    inputRef={register}
                    label="Asthma - Moderate/Severe "
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="mildAnxietyDepression"
                    id="mildAnxietyDepression"
                    checked={props.formState.mildAnxietyDepression}
                    onChange={(e) => handleCheckBoxValue('mildAnxietyDepression', e.target.checked)}
                    errors={errors && errors.mildAnxietyDepression}
                    inputRef={register}
                    label="Anxiety/Depression-Mild/Moderate/Situational"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="severeAnxietyDepression"
                    id="severeAnxietyDepression"
                    checked={props.formState.severeAnxietyDepression}
                    onChange={(e) => handleCheckBoxValue('severeAnxietyDepression', e.target.checked)}
                    errors={errors && errors.severeAnxietyDepression}
                    inputRef={register}
                    label="Anxiety/Depression- Severe"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="bipolar"
                    id="bipolar"
                    checked={props.formState.bipolar}
                    onChange={(e) => handleCheckBoxValue('bipolar', e.target.checked)}
                    errors={errors && errors.bipolar}
                    inputRef={register}
                    label="Bipolar"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="cardiovascularheartDisease"
                    id="cardiovascularheartDisease"
                    checked={props.formState.cardiovascularheartDisease}
                    onChange={(e) => handleCheckBoxValue('cardiovascularheartDisease', e.target.checked)}
                    errors={errors && errors.cardiovascularheartDisease}
                    inputRef={register}
                    label="Cardiovascular/Heart Disease"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="cancer"
                    id="cancer"
                    checked={props.formState.cancer}
                    onChange={(e) => handleCheckBoxValue('cancer', e.target.checked)}
                    errors={errors && errors.cancer}
                    inputRef={register}
                    label="Cancer (non-basal cell)"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="chronsUlcerativeColitis"
                    id="chronsUlcerativeColitis"
                    checked={props.formState.chronsUlcerativeColitis}
                    onChange={(e) => handleCheckBoxValue('chronsUlcerativeColitis', e.target.checked)}
                    errors={errors && errors.chronsUlcerativeColitis}
                    inputRef={register}
                    label="Crohn's/Ulcerative Colitis"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="copd"
                    id="copd"
                    checked={props.formState.copd}
                    onChange={(e) => handleCheckBoxValue('copd', e.target.checked)}
                    errors={errors && errors.copd}
                    inputRef={register}
                    label="COPD"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="diabetes"
                    id="diabetes"
                    checked={props.formState.diabetes}
                    onChange={(e) => handleCheckBoxValue('diabetes', e.target.checked)}
                    errors={errors && errors.diabetes}
                    inputRef={register}
                    label="Diabetes (Type 1, Type 2, or Pre-Diabetes)"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="hivaids"
                    id="hivaids"
                    checked={props.formState.hivaids}
                    onChange={(e) => handleCheckBoxValue('hivaids', e.target.checked)}
                    errors={errors && errors.hivaids}
                    inputRef={register}
                    label="HIV/AIDS"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="highCholesterol"
                    id="highCholesterol"
                    checked={props.formState.highCholesterol}
                    onChange={(e) => handleCheckBoxValue('highCholesterol', e.target.checked)}
                    errors={errors && errors.highCholesterol}
                    inputRef={register}
                    label="High Cholesterol"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="hypertensionOrHighBloodPressure"
                    id="hypertensionOrHighBloodPressure"
                    checked={props.formState.hypertensionOrHighBloodPressure}
                    onChange={(e) => handleCheckBoxValue('hypertensionOrHighBloodPressure', e.target.checked)}
                    errors={errors && errors.hypertensionOrHighBloodPressure}
                    inputRef={register}
                    label="Hypertension or High Blood Pressure"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="kidneyDisease"
                    id="kidneyDisease"
                    checked={props.formState.kidneyDisease}
                    onChange={(e) => handleCheckBoxValue('kidneyDisease', e.target.checked)}
                    errors={errors && errors.kidneyDisease}
                    inputRef={register}
                    label="Kidney Disease"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="rheumatoidArthritis"
                    id="rheumatoidArthritis"
                    checked={props.formState.rheumatoidArthritis}
                    onChange={(e) => handleCheckBoxValue('rheumatoidArthritis', e.target.checked)}
                    errors={errors && errors.rheumatoidArthritis}
                    inputRef={register}
                    label="Rheumatoid Arthritis"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="sleepApnea"
                    id="sleepApnea"
                    checked={props.formState.sleepApnea}
                    onChange={(e) => handleCheckBoxValue('sleepApnea', e.target.checked)}
                    errors={errors && errors.sleepApnea}
                    inputRef={register}
                    label="Sleep Apnea"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="strokeTia"
                    id="strokeTia"
                    checked={props.formState.strokeTia}
                    onChange={(e) => handleCheckBoxValue('strokeTia', e.target.checked)}
                    errors={errors && errors.strokeTia}
                    inputRef={register}
                    label="Stroke/TIA"
                  />
                  <CheckboxInput
                    className="checkBoxInput"
                    name="none"
                    id="none"
                    checked={props.formState.none}
                    onChange={(e) => handleCheckBoxValue('none', e.target.checked)}
                    errors={errors.none}
                    inputRef={register}
                    label="None of the above"
                    disabled={noneOfTheAboveDisabled}
                  />
                </FormGroup>
              </Row>
            </Col>
          </Row>
          {/* Buttons */}
          <Row className="pre-quote-nav-control">
            <Col className="text-left btn-back">
              <Button variant="outlined" size="medium" color="primary" className="px-4" onClick={props.onBack}>
                BACK
              </Button>
            </Col>
            <Col className="text-right">
              <Button variant="contained" size="medium" color="primary" type="submit" className="px-4">
                NEXT
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </ThemeProvider>
  );
}

function checkBoxValidation(
  mildAsthma,
  severeAsthma,
  mildAnxietyDepression,
  severeAnxietyDepression,
  bipolar,
  cardiovascularheartDisease,
  cancer,
  chronsUlcerativeColitis,
  copd,
  diabetes,
  hivaids,
  highCholesterol,
  hypertensionOrHighBloodPressure,
  kidneyDisease,
  rheumatoidArthritis,
  sleepApnea,
  strokeTia
) {
  if (
    mildAsthma === false &&
    severeAsthma === false &&
    mildAnxietyDepression === false &&
    severeAnxietyDepression === false &&
    bipolar === false &&
    cardiovascularheartDisease === false &&
    cancer === false &&
    chronsUlcerativeColitis === false &&
    copd === false &&
    diabetes === false &&
    hivaids === false &&
    highCholesterol === false &&
    hypertensionOrHighBloodPressure === false &&
    kidneyDisease === false &&
    rheumatoidArthritis === false &&
    sleepApnea === false &&
    strokeTia === false
  )
    return true;
  else return false;
}

MedicalHistory.ValidationSchema = object().shape({
  none: string()
    .required()
    .when(
      [
        'mildAsthma',
        'severeAsthma',
        'mildAnxietyDepression',
        'severeAnxietyDepression',
        'bipolar',
        'cardiovascularheartDisease',
        'cancer',
        'chronsUlcerativeColitis',
        'copd',
        'diabetes',
        'hivaids',
        'highCholesterol',
        'hypertensionOrHighBloodPressure',
        'kidneyDisease',
        'rheumatoidArthritis',
        'sleepApnea',
        'strokeTia',
      ],
      {
        is: (
          mildAsthma,
          severeAsthma,
          mildAnxietyDepression,
          severeAnxietyDepression,
          bipolar,
          cardiovascularheartDisease,
          cancer,
          chronsUlcerativeColitis,
          copd,
          diabetes,
          hivaids,
          highCholesterol,
          hypertensionOrHighBloodPressure,
          kidneyDisease,
          rheumatoidArthritis,
          sleepApnea,
          strokeTia
        ) =>
          checkBoxValidation(
            mildAsthma,
            severeAsthma,
            mildAnxietyDepression,
            severeAnxietyDepression,
            bipolar,
            cardiovascularheartDisease,
            cancer,
            chronsUlcerativeColitis,
            copd,
            diabetes,
            hivaids,
            highCholesterol,
            hypertensionOrHighBloodPressure,
            kidneyDisease,
            rheumatoidArthritis,
            sleepApnea,
            strokeTia
          ),
        then: string().matches(/^true/, 'Please check one checkbox.'),
        otherwise: string().required('This field is required.'),
      }
    ),
});

MedicalHistory.DefaultFormState = (prefill = false) => {
  return {
    mildAsthma: false,
    severeAsthma: false,
    mildAnxietyDepression: false,
    severeAnxietyDepression: false,
    bipolar: false,
    cardiovascularheartDisease: false,
    cancer: false,
    chronsUlcerativeColitis: false,
    copd: false,
    diabetes: false,
    hivaids: false,
    highCholesterol: false,
    hypertensionOrHighBloodPressure: false,
    kidneyDisease: false,
    rheumatoidArthritis: false,
    sleepApnea: false,
    strokeTia: false,
    none: true,
  };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/MedicalHistory.js